"use strict";
// The one guard every spreadsheet export uses (review R1 and W1, 2026-11-02): the access log, the event log, the
// pipeline and report CSVs, the positions ledger, the JEV corrections, the ranking workbook and the browser's
// "Export selected". One rule, so a hole fixed in one export can't stay open in another.
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFormulaLike = isFormulaLike;
exports.csvCell = csvCell;
/**
 * A cell a spreadsheet would run. `=`, `+`, `-` and `@` start a formula, and a leading tab or carriage return is dropped
 * by some readers so the next character starts one.
 */
const FORMULA_START = /^[=+\-@\t\r]/;
/** A plain number ("-2", "+7.5", a mobile number "+8801712345678") is a value, not a formula, and is left as it is. */
const PLAIN_NUMBER = /^[+-]?\d+(?:\.\d+)?$/;
/** A cell holding any of these must be quoted, or it breaks the row. */
const NEEDS_QUOTES = /[",\r\n]/;
/**
 * Whether a spreadsheet could run this text as a formula. "-2+3+cmd|' /C calc'!A0" and "+1+HYPERLINK(…)" start with a
 * sign and a digit but are not numbers, so they count.
 */
function isFormulaLike(text) {
    return FORMULA_START.test(text) && !PLAIN_NUMBER.test(text);
}
/** One CSV cell: a formula-like text gets a leading `'` so it stays text, and anything that would break the row is quoted. */
function csvCell(text) {
    const safe = isFormulaLike(text) ? `'${text}` : text;
    if (!NEEDS_QUOTES.test(safe))
        return safe;
    return `"${safe.replace(/"/g, '""')}"`;
}
//# sourceMappingURL=csv-cell.js.map